import React from "react";
import Section from "./../Section";
import SectionHeader from "./../SectionHeader";
import TeamBios from "./../TeamBios";
import "./styles.scss";

function TeamBiosSection(props) {
  return (
    <Section color={props.color} size={props.size}>
      <div className="container">
        <SectionHeader
          title={props.title}
          subtitle={props.subtitle}
          centered={true}
          size={3}
        />
        <TeamBios
          people={[
            {
              avatar:
                "https://ca.slack-edge.com/T025MV4TU-UASGSB2SV-666a3af1aaf0-128",
              name: "Alan Falloon",
              role: "Planeteer"
            },
            {
              avatar:
                "https://ca.slack-edge.com/T025MV4TU-UDWSNNHF0-g2b22833d61c-128",
              name: "Andy Deng",
              role: "Planeteer"
            },
            {
              avatar:
                "https://ca.slack-edge.com/T025MV4TU-U027U0ZA6-db7d41cf49c5-128",
              name: "Helen Simonson",
              role: "Planeteer"
            },
            {
              avatar:
                "https://ca.slack-edge.com/T025MV4TU-U028TN85D-OS2311331288-128",
              name: "Josh Baker",
              role: "Planeteer"
            },
            {
              avatar:
                "https://ca.slack-edge.com/T025MV4TU-U4CBVRCMC-c402926b6b7d-128",
              name: "Pearl Robin",
              role: "Planeteer"
            },
            {
              avatar:
                "https://ca.slack-edge.com/T025MV4TU-U1BEZEQJJ-6aad6a70b138-128",
              name: "Seth Corker",
              role: "Planeteer"
            },
            {
              avatar:
                "https://ca.slack-edge.com/T025MV4TU-U02AV3Q2X-1f00babde68a-128",
              name: "Simon Duffield",
              role: "Planeteer"
            }
          ]}
        />
      </div>
    </Section>
  );
}

export default TeamBiosSection;
